/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import Home from './views/Home';
import PresentationView from './views/Presentation';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import PagerDutyIncidents from './views/PagerDutyIncidents/components/PagerDutyIncidents.js';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			// projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Home(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/pagerDutyIncidents',
		exact: true,
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			operator: ['Vantage'],
			projects: ['Vantage SP'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: PagerDutyIncidents(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/dashboards',
		component: () => AuthGuard({
			operator: ['Vantage'],
			projects: ['Vantage SP'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/executiveSummary',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 7 } }, pageTitle: 'Executive Summary', module: 'Dashboards' })
								}),
							},
							{
								path: '/dashboards/alarms',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Alarms', module: 'Dashboards' })
								}),
							},
							{
								path: '/dashboards/incidents/overall',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 6 } }, pageTitle: 'Overall', module: 'Dashboards' })
								}),
							},
							{
								path: '/dashboards/incidents/monthly',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 4 } }, pageTitle: 'Monthly', module: 'Dashboards' })
								}),
							},
							{
								path: '/dashboards/incidents/weekly',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 5 } }, pageTitle: 'Weekly', module: 'Dashboards' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							}
						],
					}
				}
			)
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),

	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},

	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
];

export default routes;
